import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["label"];
  static values = {
    formId: String,
    inputName: String
  };

  select(event) {
    event.preventDefault();
    const { value, label } = event.currentTarget.dataset;
    if (!value) return;

    const form = document.getElementById(this.formIdValue);
    if (!form) return;

    const input = form.querySelector(`input[name="${this.inputNameValue}"]`);
    if (input) input.value = value;

    document.querySelectorAll(`[data-controller~="tuitions-date-basis"]`).forEach((scope) => {
      scope.querySelectorAll('[data-tuitions-date-basis-target~="label"]').forEach((el) => {
        el.textContent = label;
      });
      scope.querySelectorAll('.dropdown-item').forEach((item) => {
        item.classList.toggle('active', item.dataset.value === value);
      });
    });

    if (typeof form.requestSubmit === 'function') {
      form.requestSubmit();
    } else {
      form.submit();
    }
  }
}
